
import { Component, Prop, Vue } from "vue-property-decorator";
import ETable from "@/components/ETable.vue";
import { prescriptionModuleNameList, savePrescriptionModuleName } from "@/api/prescriptionDb";

@Component({ name: 'prescription-db-component-moduleNameConfig',
  components: { ETable },
})
export default class ModuleNameConfig extends Vue {
  @Prop() readonly merchantId!: string | number;
  @Prop() readonly brandName!: string;

  moduleColumns = [
    { prop: "originalName", label: "原处方模块名称", minWidth: "200" },
    { prop: "customName", label: "新处方模块名称", minWidth: "200" },
    { prop: "modifiedBy", label: "操作人", minWidth: "140" },
    { prop: "modifiedTime", label: "最后操作时间", minWidth: "200" },
    { prop: "action", label: "操作", minWidth: "120" },
  ];
  moduleList: any[] = [];
  moduleLoading = false;
  moduleDialogVisible = false;
  moduleSaveLoading = false;
  editModule: any = {
    moduleCode: "",
    originalName: "",
    customName: "",
    initialName: "",
  };
  moduleRules = {
    customName: [
      { required: true, message: "请输入新处方模块名称", trigger: "blur" },
      { max: 10, message: "处方模块名称最多10个字", trigger: "blur" },
    ],
  };

  mounted() {
    this.getModuleNameList();
  }

  // 获取处方模块名称配置列表
  getModuleNameList() {
    if (!this.merchantId) return;
    this.moduleLoading = true;
    prescriptionModuleNameList({ merchantId: this.merchantId }).then((res: any) => {
      this.moduleList = res.data || [];
    }).finally(() => {
      this.moduleLoading = false;
    });
  }

  // 打开编辑弹窗：customName 为空时带出 originalName
  handleEditModule(row: any) {
    const customName = row.customName || row.originalName || "";
    this.editModule = {
      moduleCode: row.moduleCode,
      originalName: row.originalName,
      customName,
      initialName: customName,
    };
    this.moduleDialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.moduleForm as any)?.clearValidate();
    });
  }

  // 保存处方模块名称
  saveModuleName() {
    if (!this.editModule.moduleCode) return;
    (this.$refs.moduleForm as any).validate((valid: boolean) => {
      if (!valid) return;
      const customName = (this.editModule.customName || "").trim();
      if (!customName) {
        this.$message.warning("请输入新处方模块名称");
        return;
      }
      // 用户没改名就不调保存
      if (customName === (this.editModule.initialName || "").trim()) {
        this.moduleDialogVisible = false;
        return;
      }
      this.moduleSaveLoading = true;
      savePrescriptionModuleName({
        merchantId: this.merchantId,
        moduleCode: this.editModule.moduleCode,
        customName,
      }).then(() => {
        this.$message.success("保存成功");
        this.moduleDialogVisible = false;
        this.getModuleNameList();
      }).finally(() => {
        this.moduleSaveLoading = false;
      });
    });
  }

  // 表头样式（居中）
  headerCellStyle() {
    return { background: "#F8F9FA", color: "#1A1A1C", textAlign: "center" };
  }

  // 单元格样式（居中）
  cellStyle() {
    return { textAlign: "center" };
  }
}
